// ── Calcule la position (en %) du curseur à partir d'un événement pointeur ──
const getPositionFromEvent = (wrapper, isVertical, event) => {
  const rect = wrapper.getBoundingClientRect();
  const point = event.touches ? event.touches[0] : event;

  const ratio = isVertical
    ? (point.clientY - rect.top) / rect.height
    : (point.clientX - rect.left) / rect.width;

  return Math.min(100, Math.max(0, ratio * 100));
};

const setPosition = (wrapper, handle, position) => {
  wrapper.style.setProperty('--ba-position', `${position}%`);
  handle.style.setProperty('--ba-position', `${position}%`);
};

const gk_beforeAfterBlock = {
  load() {
    document.querySelectorAll('.BeforeAfterBlock').forEach((block) => {
      if (block.dataset.gkInit) return;
      block.dataset.gkInit = '1';

      const wrapper = block.querySelector('.BeforeAfterBlock-wrapper');
      const handle = block.querySelector('.BeforeAfterBlock-handle');
      if (!wrapper || !handle) return;

      const isVertical = wrapper.classList.contains('-orientationVertical');

      // ── Position initiale, lue depuis --ba-start-position ──
      const startPosition = parseFloat(getComputedStyle(block).getPropertyValue('--ba-start-position')) || 50;
      setPosition(wrapper, handle, startPosition);

      let dragging = false;

      const onMove = (event) => {
        if (!dragging) return;
        const position = getPositionFromEvent(wrapper, isVertical, event);
        setPosition(wrapper, handle, position);
      };

      const onStart = (event) => {
        dragging = true;
        onMove(event);
      };

      const onEnd = () => {
        dragging = false;
      };

      wrapper.addEventListener('mousedown', onStart);
      wrapper.addEventListener('touchstart', onStart, { passive: true });

      window.addEventListener('mousemove', onMove);
      window.addEventListener('touchmove', onMove, { passive: true });

      window.addEventListener('mouseup', onEnd);
      window.addEventListener('touchend', onEnd);
    });
  },
};

export default gk_beforeAfterBlock;
